import { useAuthContext } from 'contexts/AuthContext';
import useGetProFormaRoom from 'queries/ProForma/useGetProFormaRoom';
import { KeyStatsValues } from '../DealReturns/DealReturns';

interface UseGetProFormaStatsParams {
    dealId: number;
    proFormaId: number | undefined;
}

export const useGetProFormaStats = ({ dealId, proFormaId }: UseGetProFormaStatsParams) => {
    const { selectedOrganizationId } = useAuthContext();

    const { data: proFormaRoomData, isLoading } = useGetProFormaRoom(
        dealId,
        proFormaId!,
        selectedOrganizationId!,
        false,
        '',
        null,
        { enabled: !!proFormaId && !!selectedOrganizationId, staleTime: Infinity },
    );

    const keyStats: KeyStatsValues = !proFormaRoomData?.returns
        ? {
            leveredIrr: null,
            leveredEmx: null,
            developmentSpread: null,
            returnOnCost: null,
            returnOnEquity: null,
            profitReturn: null,
        }
        : {
            leveredIrr: proFormaRoomData.returns.netLeveredIrr || null,
            leveredEmx: proFormaRoomData.returns.netLeveredEquityMultiple || null,
            developmentSpread: proFormaRoomData.returns.developmentSpread?.trended || null,
            returnOnCost: proFormaRoomData.returns.yieldOnCost?.trended || null,
            returnOnEquity: proFormaRoomData.returns.leveredRoi || null,
            profitReturn: proFormaRoomData.disposition?.netSaleProceeds?.amount || null,
        };

    return {
        keyStats,
        isLoading,
        activeProFormaName: proFormaRoomData?.generalInfo?.name || 'Pro Forma',
    };
};
